import { render, staticRenderFns } from "./DueOrder.vue?vue&type=template&id=c6d86936&scoped=true&"
import script from "./DueOrder.vue?vue&type=script&lang=js&"
export * from "./DueOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d86936",
  null
  
)

export default component.exports